import React, { useState } from 'react';
import {
    Box,
    Container,
    Paper,
    Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { usePermission } from '../../hooks/usePermission';
import BrandForm from '../../Components/Brands/BrandForm';
import BrandsTable from '../../Components/Brands/BrandsTable';
import { CreateBrandsPermission } from '../../constants/permissions';

const Brands = () => {
    const { data: canCreateBrands } = usePermission({
        permissionName: CreateBrandsPermission
    });

    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        division_id: '',
    });

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setFormData({
            name: '',
            division_id: '',
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    return (
        <Container maxWidth="xl">
            <Box sx={{ py: 4 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
                    <Typography variant="h4" component="h1">
                        Brands
                    </Typography>
                    {canCreateBrands && (
                        <button
                            className='bg-blueColor text-white rounded-md px-4 py-2 flex items-center gap-2'
                            onClick={handleClickOpen}
                        >
                            <AddIcon />
                            Add New Brand
                        </button>
                    )}
                </Box>

                <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                    <BrandsTable />
                </Paper>

                <BrandForm
                    open={open}
                    onClose={handleClose}
                    formData={formData}
                    onInputChange={handleInputChange}
                />
            </Box>
        </Container>
    );
};

export default Brands; 